<template>
  <div class="">
    <div class="container-fluid secondary-bg">
      <div class="row pt-10 px-16 ">
        <div class="col-12 col-md-6 col-lg-3 white--text ">
          <h3 class="text-align font-18">{{ $getText("SERVICES") }}</h3>
          <p class="text-align">
            {{ $getText("StartApp") }}
          </p>
          <p class="text-align">
            {{ $getText("Automation") }}
          </p>
          <p class="text-align">
            {{ $getText("MobileApp") }}
          </p>
          <p class="text-align">
            {{ $getText("WebDesign") }}
          </p>
        </div>
        <div class="col-12 col-md-6 col-lg-3 white--text">
          <!--        <img :src="getImgUrl(footer.src)" class=" img-fluid  ">-->
          <h3 class="text-align font-18">تماس باما</h3>
          <p class="text-align ">
            {{ $getText('ADDRESS') }}
            <br/>
            <br/>
            <i :class="footer.phoneIcon " class="mr-2 font-18"></i>
            <a href="tel:09126483554" class="white--text">
              09126483554
            </a>
            <br/>
            <i :class="footer.phoneIcon " class="mr-2 font-18"></i>
            <a href="tel:09126770412" class="white--text">
              09126770412
            </a>
            <br/>
            <i :class="footer.phoneIcon " class="mr-2 font-18"></i>
            <a href="tel:02177185677" class="white--text">
                02177185677
            </a>
         <br/>
            <i :class="footer.emailIcon " class="mr-2 font-18"></i>
            {{ $getText("EMAIL-TEXT") }}

          </p>
          <!--        <div class="text-align">
                    <i :class="footer.facebook " class="mr-2 font-30 border rounded px-4 py-1"></i>
                    <i :class="footer.instagram " class="mr-2 font-30 border rounded px-4 py-1"></i>
                    <i :class="footer.whatsapp " class="mr-2 font-30 border rounded px-4 py-1"></i>
                  </div>-->
        </div>
        <div class="col-12 col-md-6 col-lg-3 white--text">
          <h3 class="text-align font-18">IZISYS</h3>
          <p class="text-align">
            {{ $getText("HOME_PAGE_SUPPORT_LIST_DESC2") }}
          </p>
<!--          <div class="row no-gutters">
            <v-row justify="center">
            </v-row>
            <div @click.stop="iso = true" class="col-6 text-center"><img src="../assets/img/iso.428991a8.png" class="img-fluid iso-icon " alt="iso"></div>
            <div @click.stop="anformatic = true" class="col-6 text-center"><img src="../assets/img/user-43-1555313643.jpg" class="img-fluid iso-icon " alt="anformatic"></div>

          </div>-->
          <div class="row">
            <div class="col-10 mx-auto">
              <div class="row">
                <div class="col-6  pointer p-1 mx-auto">
                  <img  @click.stop="iso = true" src="../assets/img/iso-logo.jpg" class=" img-fluid mb-3" alt="googleplay">

                </div>
                <div class="col-6  pointer p-1 mx-auto">
                  <img @click.stop="anformatic = true" src="../assets/img/anformatic-logo.jpg" class=" img-fluid" alt="appdownload">

                </div>

              </div>
            </div>

          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 white--text">
          <h3 class="text-align font-18">اپلیکیشن اندروید</h3>
          <div class="text-center">
            <a href="https://play.google.com/store/apps/details?id=com.izisys.app" target="_blank" title="دانلود اپلیکیشن IZISYS">
              <img src="../assets/img/googlePlay.54863944.png" class=" img-fluid mb-3" alt="googleplay">
            </a><!--
            <img src="../assets/img/download-apk.png" class=" img-fluid mb-3" alt="appdownload">-->
          </div>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="anformatic"
        width="800">
      <v-card class="text-center">
        <div @click.stop="anformatic" class="text-center"><img  src="../assets/img/IZISYS.jpg" class="img-fluid" alt="anfomatic"></div>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="iso"
        width="500">
      <v-card class="text-center">
        <div @click.stop="iso" class="text-center"><img src="../assets/img/ISO9001-2015.jpg" class="img-fluid" alt="iso"></div>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
export default {
  name: "FooterPages",
  data: () => ({
    anformatic: false,
    iso: false,
    footer: {},
  }),
  mounted() {
    this.footer = this.$getfooter();
  },
  methods: {

    getImgUrl(pic) {
    /*  console.log(this.getImgUrl())
      console.log("this.getImgUrl()")*/
      return require("../assets/img/" + pic);
    }
  }
}
</script>

<style scoped>

</style>
